import { indexes } from '@/mocks/chigua';

export default function IndexStrip() {
  return (
    <section id="index" className="scroll-mt-16 bg-paper-100/70 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <div className="flex items-center gap-2">
              <span className="font-heading text-sm font-bold tracking-widest text-accent-700">脉络索引</span>
              <span className="h-px w-8 bg-accent-400" />
            </div>
            <h2 className="mt-2 font-heading text-2xl font-bold text-ink-900 md:text-3xl">
              站内 6 大合集，按你要的角度切入
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-ink-500">
            想看故事、查细节、找爆料还是听分析，先选一条主线，剩下的交给合集自己讲。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 md:gap-4">
          {indexes.map((it) => (
            <a
              key={it.code}
              href="#stories"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById(it.code === '01' ? 'timeline' : 'stories')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group relative flex flex-col rounded-lg border border-paper-200 bg-paper-50 p-5 transition-all hover:border-accent-300 hover:bg-paper-50"
            >
              <div className="flex items-start justify-between">
                <span className="font-heading text-lg font-bold text-paper-300 group-hover:text-accent-300">
                  {it.code}
                </span>
                <span className="rounded-full bg-accent-100 px-2.5 py-1 text-xs font-medium text-accent-700">
                  {it.tag}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-xl font-bold text-ink-900">{it.name}</h3>
              <div className="mt-1 text-sm font-semibold text-accent-600">{it.count}</div>
              <p className="mt-3 flex-1 text-[13px] leading-[1.8] text-ink-600">{it.desc}</p>
              <div className="mt-4 flex items-center gap-1.5 text-sm font-medium text-ink-400 transition-colors group-hover:text-accent-600">
                进入合集
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}